// extracted by css-extract-rspack-plugin
export default {"Label":"Subhead-module__Label__zn3kA"};